import {useEffect} from "react";

const Chart = ({data, name, width}) => {
    useEffect(() => {
        const canvas = document.getElementById(name);
        const context = canvas.getContext("2d");
        const xoffset = 30;
        const yoffset = 60;
        const maxvalue = 10
        const minvalue = 0

        document.getElementById(name + "text").innerHTML = name + "(No Data)";

        canvas.height = 350;
        canvas.width = width;

        context.font = "Bold 20px Arial";

        context.beginPath()

        context.strokeStyle = "#999999";
        context.lineWidth = 0.5;

        for (let i = 0; i < 11; i++) {
            context.moveTo( (canvas.width - xoffset) / 10 * i + xoffset, yoffset / 2);
            context.lineTo( (canvas.width - xoffset) / 10 * i + xoffset, canvas.height - yoffset / 2);
        }

        for (let i = 0; i < 11; i++) {
            context.moveTo(xoffset, (canvas.height- yoffset) / 10 * i + yoffset/2);
            context.lineTo(canvas.width, (canvas.height- yoffset) / 10 * i + yoffset/2);
        }

        context.stroke()

        for (let i = -1; i < 10; i++) {
            context.fillText((9 - i).toString(), 0, (canvas.height- yoffset - 5) / 10 * i + yoffset + 10);
        }

        context.beginPath()

        context.strokeStyle = "lime";
        context.lineWidth = 1;

        if (data && data[0] && data[0]._start) {
            document.getElementById(name + "text").innerHTML = name;
            const start = Date.parse(data[0]._start)
            const diff = (Date.parse(data[0]._stop) - start) / 10;

            for (let i = 0; i < 10; i++) {
                context.fillText(new Date(diff * i + start).toTimeString().split(" ")[0].slice(0, 5), (canvas.width - xoffset) / 10 * i + xoffset - 25, canvas.height);
            }

            context.moveTo(xoffset,(canvas.height - yoffset / 2) - data[0]._value * ((canvas.height - yoffset) / maxvalue));

            data.forEach((item, index) => {
                context.lineTo( (canvas.width - xoffset)/ data.length * index + xoffset,(canvas.height - yoffset / 2) - item._value * ((canvas.height - yoffset) / maxvalue));
            })
        }

        context.stroke()
    }, [data])

    return (
        <div className={"bg-white shadow p-4 rounded-md"}>
            <h1 id={name + "text"} className={"text-gray-600 font-bold"}>{name} (No Data)</h1>
            <canvas className={"w-full"} id={name}></canvas>
        </div>
    )
}

export default Chart;